import { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Stack, Typography } from "@mui/material";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import { TkRouteContext } from "../../context/tkRouteContext";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkButton from "../../components/atoms/TkButton";
import "./_style.scss";

/**
 * SCRC070008 提出完了
 * 提出が完了したことを確認する。
 * @return SCRC070008
 */
const SCRC070008 = (): JSX.Element => {
  const navigate = useNavigate();
  const endPoint = useLocation().state?.endPoint;

  const { state } = useContext(GlobalContext);
  const { setState: setBusinessState } = useContext(BusinessContext);
  const { state: routerState, setState: setRouterState } =
    useContext(TkRouteContext);

  const userType = state.authInfo?.userType;
  const keiyakusya = userType === authorityUserType.userTypeNumber.KEIYAKUSYA;
  const daikosha = userType === authorityUserType.userTypeNumber.DAIKOSHA;
  const kiko = userType === authorityUserType.userTypeNumber.KIKO;

  useEffect(() => {
    setBusinessState({});
  }, [setBusinessState]);

  useEffect(() => {
    setRouterState({});
  }, [routerState.routerList, setRouterState]);

  const clickButton = () => {
    if (keiyakusya) {
      navigate("/SCRC020001");
    } else if (daikosha) {
      navigate("/SCRD310001");
    } else {
      navigate("/SCRW110001");
    }
  };

  return (
    <Stack className="SCRC070008" data-testid="SCRC070008test">
      <Stack className="complete">
        <Typography>提出完了</Typography>
      </Stack>
      <Stack className="guideMessage">
        {(!endPoint && keiyakusya) || daikosha || kiko ? (
          <Typography>{labelids.labelid.LBLC070008_02}</Typography>
        ) : (
          <Typography>{labelids.labelid.LBLC070008_03}</Typography>
        )}
      </Stack>
      {((!endPoint && keiyakusya) || daikosha || kiko) && (
        <TkButton onClick={() => clickButton()}>ホームへ戻る</TkButton>
      )}
    </Stack>
  );
};

export default SCRC070008;
